var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fentotl"},[_c('el-pagination',{staticClass:"jiange",attrs:{"current-page":_vm.currentPage,"page-sizes":_vm.pageSizes,"page-size":_vm.PageSize,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }